// extracted by mini-css-extract-plugin
export default {"yuanDynasty":"zhu-xis-legacy-yuan-dynasty_yuanDynasty__qPApw","selectedDynasty":"zhu-xis-legacy-yuan-dynasty_selectedDynasty__Er75N"};